import ITask from '../../../../../types/task';
import { ProcessInstanceFromAppTasks } from './processInstance';
import moment from 'moment';

export interface TaskFromAppTasks {
    id: string;
    assignee?: string | null;
    taskKey: string;
    formKey?: string;
    name: string;
    outcome: string;
    priority: number;
    description?: string;
    processInstanceId?: string;
    processInstance?: ProcessInstanceFromAppTasks;
    startTime: string | null;
    endTime?: string;
    dueDate?: string;
    readOnly: boolean;
    taskDefinitionKey?: string;
    linkedEntityId?: string;
    linkedEntityType?: string;
    linkedEntity?: {};
    taskPermissions: {
        canClaimTask: boolean;
        canAssignTask: boolean;
        potentialUsers: {
            id: string;
            login: string;
            title: string;
        }[];
    };
    schedDate?: string;
    schedDuration?: number;
    attendeesIds?: string[];
}

export const mapToAppType = ({
    id,
    assignee,
    formKey,
    name,
    outcome,
    dueDate,
    description,
    priority,
    startTime,
    endTime,
    processInstanceId,
    linkedEntityId,
    linkedEntityType,
    linkedEntity,
    taskPermissions,
    readOnly,
    schedDate,
    schedDuration,
    attendeesIds,
}: TaskFromAppTasks): ITask => ({
    id,
    name,
    outcome,
    priority,
    assignee: assignee || null,
    dueDate: dueDate ? new Date(dueDate) : undefined,
    description,
    formKey,
    processInstanceId,
    created: startTime ? new Date(startTime) : null,
    endDate: endTime ? new Date(endTime) : undefined, // .split('T')[0],
    linkedEntityId,
    linkedEntityType,
    linkedEntity,
    taskPermissions,
    readOnly,
    schedDate: schedDate ? new Date(schedDate) : undefined,
    schedDuration,
    attendeesIds,
});

export const mapToApiType = ({
    endDate,
    formKey,
    created,
    comments,
    dueDate,
    schedDate,
    ...rest
}: Partial<ITask>): Partial<TaskFromAppTasks> => ({
    taskKey: formKey,
    dueDate: dueDate && moment(dueDate).format('YYYY-MM-DD'),
    startTime: created && moment(created).format('YYYY-MM-DD'),
    endTime: endDate && moment(endDate).format('YYYY-MM-DD'),
    schedDate: schedDate && moment(schedDate).toISOString(false),
    ...rest,
});
